@if (options.length > 0) {
  <ng-select
    [items]="options"
    bindLabel="label"
    [placeholder]="selected ? '' : placeholder"
    [ngModel]="selected"
    (change)="onChange($event)"
    [searchable]="false"
    [markFirst]="false"
    [clearable]="false"
    class="campana-select"
    [class.campana-select--compact]="compact"
    notFoundText="No hay elementos disponibles">
  </ng-select>
}
@else {
  <ng-select
    [items]="options"
    bindLabel="label"
    [placeholder]="selected ? '' : placeholder"
    [ngModel]="selected"
    (change)="onChange($event)"
    [searchable]="false"
    [markFirst]="false"
    [clearable]="false"
    class="campana-select"
    [class.campana-select--compact]="compact"
    [class.campana-select--no-options]="hasNoOptions"
    notFoundText="No hay elementos disponibles"
    placeholder="No hay elementos disponibles">
  </ng-select>

}
